module.exports = __webpack_public_path__ + "img/nt115-04-81-1.prt.43ba3370.jpg";